import React from "react";

const isRawTextChild = (child) =>
  typeof child === "string" || typeof child === "number";

export const getFloatingExerciseLinkTriggerChildren = (children) =>
  React.Children.toArray(children).filter((child) => !isRawTextChild(child));
